module.exports = __webpack_public_path__ + "img/my-profile-fill.6ae6ae2a.svg";